module.exports = __webpack_public_path__ + "assets/img/bannoudesign-photo01.0a22d4e2.jpg";